import React from 'react';
export var defaultRetinaContext = true;
export var RetinaContext = /*#__PURE__*/React.createContext(defaultRetinaContext);